<template>

    <m-edit1/>

    <m-h1 v-bind='{...{},...{}}' :style='""' class="text-center mt-5" >
                <template #default>الطلب قيد المراجعة   </template>
                </m-h1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1';

export default {
    name: 'HomeView',
    components: {mEdit1, mH1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
